import styled from "styled-components";
import { background, size } from "./styled";

const Circle = styled.div`
  text-align: center;
  border: 1px solid black;
  border-radius: 50%;
  ${(props) => background(props)};
  ${(props) => size(props)}
`;

export default Circle;
